const signedUrlKey = 'r-series-signed-url';
const lsRetailSessionKey = 'r-series-retail-session';
const returnURLKey = 'r-series-return-url';

export function getLsRetailSession() {
    return sessionStorage.getItem(lsRetailSessionKey);
}

export function setLsRetailSession(lsRetailSession) {
    sessionStorage.setItem(lsRetailSessionKey, lsRetailSession);
}

export function setReturnURLSession(url) {
    sessionStorage.setItem(returnURLKey, url)
}

export function getReturnURLSession() {
    return sessionStorage.getItem(returnURLKey);
}

export function getSignedURL() {
    return sessionStorage.getItem(signedUrlKey);
}

function setSignedURL(url) {
    sessionStorage.setItem(signedUrlKey, url);
}

export function setSignedURLIfValid(url) {
    const urlParams = new URLSearchParams(url);

    if (
        urlParams.has("alg") &&
        urlParams.has("exp") &&
        urlParams.has("kid") &&
        urlParams.has("signature")
    ) {
        setSignedURL(url);
    }
}